import React, { FC, useCallback, useState } from 'react';
import { useHistory } from 'react-router';

import { Button, Tooltip } from 'devextreme-react';

const CreateButton: FC = () => {
  const history = useHistory();

  const [visibleTask, setVisibleTask] = useState(false);

  const toggleDefault = useCallback(() => setVisibleTask(!visibleTask), [visibleTask]);

  const createTask = () => history.push('/task/add');

  return (
    <>
      <Tooltip target="#task" position="bottom" visible={visibleTask}>
        <div>Создать новую заявку</div>
      </Tooltip>
      <span id="task" onMouseEnter={toggleDefault} onMouseLeave={toggleDefault}>
        <Button width={120} text="Создать" type="default" onClick={createTask} />
      </span>
    </>
  );
};

export default CreateButton;
